import { COMMON_FLAGS, useCommonConfig } from 'modules/taboola-common-frontend-modules/account-configurations';
import { isHTMLCardCreative } from '../config/predicates';

export const useThumbnailSrc = (value, data) => {
    const { [COMMON_FLAGS.CREATIVES_THUMBNAIL_DEFAULT_SRC]: thumbnailDefaultSrc } = useCommonConfig([
        COMMON_FLAGS.CREATIVES_THUMBNAIL_DEFAULT_SRC,
    ]);
    return !value && isHTMLCardCreative(data) ? thumbnailDefaultSrc : value;
};
